import classNames from "classnames";
import NavbarDual from "components/navbars/navbar-dual/NavbarDual";
import NavbarTopHorizontal from "components/navbars/navbar-horizontal/NavbarTopHorizontal";
import NavbarTopDefault from "components/navbars/navbar-top/NavbarTopDefault";
import NavbarVertical from "components/navbars/navbar-vertical/NavbarVertical";
import { useAppContext } from "providers/AppProvider";
import { useMainLayoutContext } from "providers/MainLayoutProvider";
import { Container } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import { useAtom } from "jotai";
import { useEffect } from "react";
import axiosInstance from "helpers/api";
import { useCookies } from "react-cookie";
import { user_info } from "jotai/UserJotaiInstance";

const MainLayout = () => {
  const {
    config: { navbarPosition },
  } = useAppContext();

  const { contentClass } = useMainLayoutContext();
  const [, setUserInfo] = useAtom(user_info);
  const [, setCookie] = useCookies(["isLoggedInKIQ"]);

  const fetchUserInfo = async () => {
    try {
      const response = await axiosInstance.get("/users/me");
      
      // Backend returns user data in response.data.user, not response.data.data.authenticatedUser
      const userData = response.data.user || response.data.data?.authenticatedUser;
      
      if (userData) {
        setUserInfo(userData);
        setCookie("isLoggedInKIQ", true);
        console.log("✅ User info loaded successfully:", userData.email);
      } else {
        console.warn("⚠️ No user data found in response");
        // Don't immediately set cookie to false - this could cause redirect loops
        // The ProtectedRoute will handle authentication redirects
      }
    } catch (error: any) {
      console.error("❌ Failed to fetch user info:", error);
      
      // Only clear authentication if it's a 401 (Unauthorized) error
      // Other errors (500, network issues) shouldn't trigger re-authentication
      if (error.response?.status === 401) {
        console.log("🚪 [AUTH] 401 error - clearing authentication");
        setCookie("isLoggedInKIQ", false);
        localStorage.removeItem("auth_token");
        localStorage.removeItem("user_info");
      } else {
        console.log("⚠️ [AUTH] Non-auth error - keeping user logged in");
      }
    }
  };

  useEffect(() => {
    fetchUserInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container fluid className="px-0">
      {(navbarPosition === "vertical" || navbarPosition === "combo") && (
        <NavbarVertical />
      )}
      {navbarPosition === "vertical" && <NavbarTopDefault />}
      {(navbarPosition === "horizontal" || navbarPosition === "combo") && (
        <NavbarTopHorizontal />
      )}
      {navbarPosition === "dual" && <NavbarDual />}

      <div className={classNames(contentClass, "content")}>
        <Outlet />
      </div>
    </Container>
  );
};

export default MainLayout;
